import { ReactNode } from 'react';

import { Badge } from '@mui/material';

import { useAuthContext } from 'context/AuthContext';

export function MenuSystemSessionBadge({ children }: { children: ReactNode }) {
    const { sessionState } = useAuthContext();

    return (
        <Badge
            variant="dot"
            invisible={sessionState.status !== 'ending'}
            sx={{
                '& .MuiBadge-badge': {
                    'top': 2,
                    'right': 2,
                    'width': 8,
                    'height': 8,
                    'backgroundColor': 'common.white',
                    'color': 'common.white',
                    'borderRadius': '50%',
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        animation: 'ripple 2s infinite ease-in-out',
                        border: '1px solid currentColor',
                        content: '""',
                    },
                },
                '@keyframes ripple': {
                    '0%': { transform: 'scale(0)', opacity: 1 },
                    '100%': { transform: 'scale(2.4)', opacity: 0 },
                },
            }}
        >
            {children}
        </Badge>
    );
}
